import { inject, Injectable } from '@angular/core';
import { Environment } from '@rma/generic/util/environment';
import { FeatureFlags, FeaturesService } from '@rma/generic/util/feature-flags';
import { ProfileDetailsContextService } from '@rma/profile/public/api-profile-details';
import { cache } from 'decorator-cache-getter';
import { combineLatest, Observable, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { PromotionType } from './promotion-type.enum';

@Injectable({
  providedIn: 'root',
})
export class AwardsOverrideService {
  private readonly profileContextService = inject(ProfileDetailsContextService);
  private readonly featuresService = inject(FeaturesService);
  private readonly environment = inject(Environment);

  @cache
  public get awardsAd$(): Observable<PromotionType | null> {
    // Not introducing a feature flag for this.
    if (this.environment.countryCode !== 'US') {
      return of(null);
    }

    const isAwardWinner$ = this.profileContextService.profileSummary$.pipe(map((p) => p.isAwardWinner ?? false));
    const is2025$ = this.featuresService.getLiveFeature$(FeatureFlags.AwardsCurrentYear, 2024).pipe(map((year) => year === 2025));

    return combineLatest([isAwardWinner$, is2025$]).pipe(
      switchMap(([isAwardWinner, is2025]) => (isAwardWinner && is2025 ? of('AwardWinner' as const) : of(null))),
    );
  }
}
